module.exports = __webpack_public_path__ + "static/media/photo.10606bb9.png";